import { GetApiData } from "../../utils/http-client";

export const GetUserCompanies = function (id) {
    return GetApiData(`/user/companies`, 'GET', null, true);
}